import { Grid, Box, Divider } from '@material-ui/core'

import { Page, Container } from 'components'

import {
  Menu,
  OnPage,
  ButtonBaseComponent,
  Title,
  Paragraph,
  Section,
} from '../../components'

import Plans from 'images/documentation/platform/plans.png'
import NewPlans from 'images/documentation/platform/newPlans.png'
import PlansSelect from 'images/documentation/platform/plansSelect.png'

import { routes } from 'Routes'

const PlansPlatform = () => {
  const onPage = [
    ['#d-planos', 'Planos'],
    ['#d-novoPlano', 'Novo Plano'],
  ]
  // const Code = ({ children }) => {
  //   return (
  //     <span
  //       style={{
  //         backgroundColor: '#e2f4f9',
  //         border: '1px solid #63bbdb',
  //         textTransform: 'lowercase',
  //         padding: '1px',
  //         fontSize: '12px',
  //         fontWeight: 400,
  //         width: 'auto',
  //         borderRadius: '4px',
  //       }}
  //     >
  //       {children}
  //     </span>
  //   )
  // }

  return (
    <Page title="Planos">
      <Container maxWidth="md">
        <Box style={{ marginBottom: '40px' }}>
          <Grid container spacing={8}>
            <Grid item xs={12} sm={12} md={12} lg={2}>
              <Menu />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={8}>
              <Box style={{ marginBottom: '40px' }}>
                <Title variant="h5" id="d-planos" subtitle="Plataforma">
                  Planos
                </Title>
                <Paragraph>
                  A página de planos é essencial para configurar sua assinatura.
                  Ao criar os planos, você poderá compartilhar um link com seus
                  clientes, permitindo que eles visualizem os planos disponíveis
                  e adquiram o que desejarem.
                  <br />
                  <br />
                  <img
                    src={Plans}
                    width="100%"
                    style={{ border: '1px solid silver', borderRadius: '20px' }}
                    alt="Página de planos da plataforma"
                  />
                  <br />
                  <br />
                  Na listagem de planos, é possível alternar entre ocultar e
                  exibir um plano. Essa funcionalidade controla a visibilidade
                  dos cartões de planos na página de planos, onde os clientes
                  podem escolher a opção que melhor atenda às suas necessidades.
                  É possível criar, visualizar e editar planos, além de acessar
                  a página específica para visualização detalhada dos planos.
                  <br />
                  <br />
                  <img
                    src={PlansSelect}
                    width="100%"
                    style={{ border: '1px solid silver', borderRadius: '20px' }}
                    alt="Seleção de planos na plataforma"
                  />
                </Paragraph>
              </Box>
              <Divider />
              <Section>
                <Title variant="h6" id="d-novoPlano">
                  Novo Plano
                </Title>
                <br />
                <br />
                <img
                  src={NewPlans}
                  width="100%"
                  style={{ border: '1px solid silver', borderRadius: '20px' }}
                  alt="Tela de criação de novo plano"
                />
                <br />
                <br />
                <Paragraph>
                  Na página de visualização, criação ou edição de planos, estão
                  disponíveis os seguintes dados:
                  <br />
                  <br />
                  <Box ml={10}>
                    <ul>
                      <li>
                        <b>Código:</b> Campo destinado ao código do plano, que
                        será utilizado para sua identificação futura.
                      </li>
                      <li>
                        <b>Nome do plano:</b> Exibe o nome do plano que será
                        apresentado na página de planos.
                      </li>
                      <li>
                        <b>Descrição:</b> Descrição detalhada do plano, exibida
                        no cartão da página de planos.
                      </li>
                      <li>
                        <b>Preço:</b> Valor do plano, definido conforme a
                        periodicidade selecionada.
                      </li>
                      <li>
                        <b>Periodicidade:</b> Indica o intervalo de recorrência
                        da cobrança. Por exemplo, mensal significa cobrança a
                        cada mês; bimestral, a cada dois meses; e assim por
                        diante.
                      </li>
                    </ul>
                  </Box>
                </Paragraph>
              </Section>
              <Divider />
              <Grid container>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <ButtonBaseComponent
                    nextName="Saques"
                    previousName="Assinatura"
                    previousRoute={routes.documentation.chargePlatform}
                    nextRoute={routes.documentation.withdrawsPlatform}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={2}>
              <OnPage page={onPage} />
            </Grid>
          </Grid>
        </Box>
      </Container>
    </Page>
  )
}

export default PlansPlatform
